<div class="flex h-full min-h-0 flex-col">
  <div class="relative z-30 shrink-0 bg-white pb-2">
    <div class="mb-3 flex h-10 items-center">
      <aw-section-headline size="medium">
        {{ cmsTextProvider.sortiment.ticketSortGroups }}
      </aw-section-headline>
    </div>
    <div class="flex flex-wrap items-center gap-3">
      <aw-search-bar
        class="min-w-40 flex-1"
        appearance="comfortable"
        [formControl]="filterForm.controls.search"
        [placeholder]="cmsTextProvider.sortiment.searchPlaceholder">
      </aw-search-bar>

      <div class="relative shrink-0">
        <button
          type="button"
          class="border-standard-outline-light hover:bg-standard-hover-main flex h-10 cursor-pointer items-center gap-1.5 rounded-md border px-3 text-base"
          #sortAnchor
          popovertarget="sortiment-sort-menu"
          aria-haspopup="menu"
          [attr.aria-expanded]="isSortMenuOpen()">
          <span class="material-symbols-rounded text-xl!" aria-hidden="true">
            sort
          </span>
          <span>{{ cmsTextProvider.sortiment.sortPlaceholder }}</span>
          <span class="material-symbols-rounded text-xl!" aria-hidden="true">
            keyboard_arrow_down
          </span>
        </button>

        <div
          #sortMenu
          id="sortiment-sort-menu"
          popover="auto"
          role="menu"
          (toggle)="onMenuToggle($event, sortAnchor, 'sort')"
          class="border-standard-outline-light fixed inset-auto m-0 w-48 max-w-[calc(100vw-1rem)] overflow-y-auto rounded-lg border bg-white py-1 shadow-lg">
          @for (option of sortOptions; track option.value) {
            <button
              type="button"
              role="menuitem"
              class="hover:bg-standard-hover-main flex w-full cursor-pointer items-center justify-between px-4 py-3 text-left text-base"
              [class.bg-standard-selected]="selectedSort() === option.value"
              (click)="selectSort(option.value); sortMenu.hidePopover()">
              <span>{{ option.label }}</span>
              @if (selectedSort() === option.value) {
                <span
                  class="material-symbols-rounded text-lg!"
                  aria-hidden="true">
                  check
                </span>
              }
            </button>
          }
        </div>
      </div>
      <div class="relative shrink-0">
        <button
          type="button"
          class="border-standard-outline-light hover:bg-standard-hover-main flex h-10 cursor-pointer items-center gap-1.5 rounded-md border px-3 text-base"
          #filterAnchor
          popovertarget="sortiment-filter-menu"
          aria-haspopup="dialog"
          [attr.aria-expanded]="isFilterMenuOpen()">
          <span class="material-symbols-rounded text-xl!" aria-hidden="true">
            filter_list
          </span>
          <span>{{ cmsTextProvider.sortiment.filterPlaceholder }}</span>
        </button>

        <div
          id="sortiment-filter-menu"
          popover="auto"
          role="dialog"
          [attr.aria-label]="cmsTextProvider.sortiment.filterPlaceholder"
          (toggle)="onMenuToggle($event, filterAnchor, 'filter')"
          class="border-standard-outline-light fixed inset-auto m-0 w-64 max-w-[calc(100vw-1rem)] overflow-visible rounded-xl border bg-white p-4 shadow-lg">
          <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-1">
              <div class="text-base font-medium">
                {{ cmsTextProvider.sortiment.filterType }}
              </div>
              <aw-multi-select-drop-down
                id="ticket-type-filter"
                appearance="compact"
                [formControl]="filterForm.controls.filterType"
                [options]="ticketTypes"
                name="name"
                valueAttribute="value"
                [placeholder]="cmsTextProvider.sortiment.typePlaceholder" />
            </div>
            <div class="flex flex-col gap-1">
              <div class="text-base font-medium">
                {{ cmsTextProvider.sortiment.filterStatus }}
              </div>
              <aw-drop-down
                id="ticket-status-filter"
                appearance="compact"
                [formControl]="filterForm.controls.filterStatus"
                [options]="ticketStatuses"
                [searchable]="false"
                [showClearOption]="true"
                [clearOptionLabel]="cmsTextProvider.sortiment.notSpecified"
                name="name"
                valueAttribute="value"
                [placeholder]="cmsTextProvider.sortiment.statusPlaceholder" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="border-standard-outline-light mt-2 min-h-0 flex-1 overflow-y-auto rounded-lg border">
    @if (isLoading() && tickets().length === 0) {
      <div role="status" class="p-6 text-center">
        {{ cmsTextProvider.sortiment.loadingProducts }}
      </div>
    } @else if (hasError()) {
      <div
        role="alert"
        class="flex flex-col items-center gap-3 p-6 text-center">
        <span>{{ cmsTextProvider.sortiment.loadingFailed }}</span>
        <button
          type="button"
          class="text-primary-main cursor-pointer underline"
          (click)="retry.emit()">
          {{ cmsTextProvider.sortiment.retryLoading }}
        </button>
      </div>
    } @else if (filteredTickets().length !== 0) {
      <aw-section
        [withoutContentPadding]="true"
        class="block w-full"
        testIdAffix="ticket-sort-buttons">
        <div class="flex flex-col gap-1 p-3">
          @for (ticketSort of filteredTickets(); track ticketSort.id) {
            <aw-ticket-sort-button
              [ticketSort]="ticketSort"
              [isSelected]="selectedTicketId() === ticketSort.id"
              [isEdited]="editedTicketIds().has(ticketSort.id)"
              [isLayoutCompleted]="
                completedLayoutTicketIds().has(ticketSort.id)
              "
              (click)="ticketSelected.emit(ticketSort.id)" />
          }
        </div>
      </aw-section>
    } @else {
      <div role="status" class="p-6 text-center">
        {{ cmsTextProvider.sortiment.noProducts }}
      </div>
    }
  </div>
</div>
